// client/src/hooks/useGaleria.js
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import apiClient from '../services/api';
import { useState, useCallback } from 'react';
import useAlert from './useAlert'; // ✅ CORREÇÃO: Importando o novo hook 'useAlert'.

const GALERIA_QUERY_KEY = 'galeria';

export const useGaleria = (params = {}) => {
    return useQuery({
        queryKey: [GALERIA_QUERY_KEY, params],
        queryFn: async () => {
            const { data } = await apiClient.get('/galeria', { params });
            return {
                imagens: data.data || [],
                pagination: data.pagination || {},
                count: data.totalCount || 0
            };
        }
    });
};

export const useMutateGaleria = () => {
    const queryClient = useQueryClient();
    const { setAlert } = useAlert(); // ✅ CORREÇÃO: Usando o novo hook 'useAlert'.

    const invalidateGaleria = () => {
        queryClient.invalidateQueries({ queryKey: [GALERIA_QUERY_KEY] });
    };

    const addImagem = useMutation({
        mutationFn: (formData) => apiClient.post('/galeria', formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        }),
        onSuccess: () => {
            invalidateGaleria();
            setAlert('Imagem adicionada à galeria com sucesso!', 'success');
        },
        onError: (err) => {
            setAlert(err.response?.data?.error || 'Erro ao adicionar imagem', 'danger');
        }
    });

    const updateImagem = useMutation({
        mutationFn: ({ id, data }) => apiClient.put(`/galeria/${id}`, data),
        onSuccess: () => {
            invalidateGaleria();
            setAlert('Dados da imagem atualizados!', 'success');
        },
        onError: (err) => {
            setAlert(err.response?.data?.error || 'Erro ao atualizar imagem', 'danger');
        }
    });

    const deleteImagem = useMutation({
        mutationFn: (id) => {
            if (window.confirm('Tem certeza? A imagem será removida da galeria permanentemente.')) {
                return apiClient.delete(`/galeria/${id}`);
            }
            return Promise.reject('Ação cancelada');
        },
        onSuccess: () => {
            invalidateGaleria();
            setAlert('Imagem removida da galeria.', 'success');
        },
        onError: (err) => {
            if (err !== 'Ação cancelada') {
                setAlert(err.response?.data?.error || 'Erro ao deletar imagem', 'danger');
            }
        }
    });

    return { addImagem, updateImagem, deleteImagem };
};

// Este hook é para estado local da UI, não precisa de alterações.
export const useCurrentImagem = () => {
    const [currentImagem, setCurrentImagem] = useState(null);
    
    const setCurrent = useCallback((imagem) => {
        setCurrentImagem(imagem);
    }, []);

    const clearCurrent = useCallback(() => {
        setCurrentImagem(null);
    }, []);

    return { currentImagem, setCurrent, clearCurrent };
};